module.exports = __webpack_public_path__ + "img/image38.cfb055ad.png";